import React from 'react'
import { Typography } from '@mui/material'
import TimelineElementBody from '../timeline-element/timeline-element-body'
import { RejectAbsenceButtonContent } from './styles'
import type { AbsenceRequestInfoProps } from './types'

const AbsenceRequestInfo: React.FC<AbsenceRequestInfoProps> = ({ task, timelineItem }) => {
  const { comment, triggeredByUserName } = task
  const { absenceDetails } = timelineItem?.content ?? {}
  const { absenceType, dayTime, singleDay, dateFrom, dateTo, dates } = absenceDetails ?? {}
  const absenceText = singleDay ? dayTime : absenceType
  const showTimelineTime = Boolean(absenceText)

  return (
    <RejectAbsenceButtonContent>
      <Typography variant="body2">{triggeredByUserName}</Typography>
      <TimelineElementBody
        dates={dates}
        dateFrom={dateFrom}
        dateTo={dateTo}
        showTimelineTime={showTimelineTime}
        comment={comment ?? undefined}
        absenceText={absenceText}
      />
    </RejectAbsenceButtonContent>
  )
}

export default AbsenceRequestInfo
